import { useContext } from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { HookFormContext } from 'components/cef_form/hook-form/providers/HookFormProvider';
import Select from 'components/ui-components/Select';
import provideHookFormFieldErrors from 'utils/hook-form/provideHookFormErrors';

const HookFormSelect = ({
  className,
  variant,
  id,
  label,
  placeholder,
  selectItems,
  value,
  rules,
}) => {
  const { control, errors, handleBlur } = useContext(HookFormContext);

  return (
    <Controller
      name={id}
      control={control}
      rules={rules}
      render={({ field }) => (
        <Select
          className={className}
          variant={variant}
          id={id}
          label={label}
          placeholder={placeholder}
          selectItems={selectItems}
          value={value || field.value}
          onChange={field.onChange}
          onBlur={handleBlur ? () => handleBlur(id) : undefined}
          errors={
            Object.keys(errors).length
              ? provideHookFormFieldErrors(id, errors)
              : null
          }
        />
      )}
    />
  );
};

HookFormSelect.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  selectItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  rules: PropTypes.object,
};

export default HookFormSelect;
